import { create } from 'zustand';
import type { ID, PublicUser, WalkieTarget } from '@itsappy/shared';

interface Speaker {
  user: PublicUser;
  /** The channel or space their held button is pointed at. */
  target: WalkieTarget;
}

interface WalkieState {
  /** Everyone whose held button is currently reaching this browser. */
  speakers: Speaker[];
  /**
   * The target this browser is transmitting into, as a `walkieTargetKey`.
   *
   * A key rather than an id because a channel and a space can hold the same
   * button, and "am I the one talking" must not be answered by an id that
   * belongs to the other kind of room.
   */
  sending: string | null;
  began: (speaker: Speaker) => void;
  ended: (userId: ID) => void;
  setSending: (key: string | null) => void;
}

export const useWalkie = create<WalkieState>((set) => ({
  speakers: [],
  sending: null,
  began: (speaker) =>
    set((state) => ({
      // A second press from the same person replaces the first rather than
      // listing them twice: one radio, one voice.
      speakers: [...state.speakers.filter((s) => s.user.id !== speaker.user.id), speaker],
    })),
  ended: (userId) =>
    set((state) => ({ speakers: state.speakers.filter((s) => s.user.id !== userId) })),
  setSending: (key) => set({ sending: key }),
}));
